import { useTranslation } from "react-i18next";
import { DateMarker } from "components/charts";
import { Text } from "components/text";
import { cn } from "utils";
import type { MetadataEvent } from "../../hooks/useMetadataEvents";
import { MetadataEventClusterMarkerRow } from "./MetadataEventClusterMarkerRow";

export const MetadataEventClusterMarker = ({
  xValue,
  events,
  date,
  onClick,
}: {
  xValue: string;
  events: MetadataEvent[];
  date: Date;
  onClick?: () => void;
}) => {
  const { t } = useTranslation(["productDetails"]);

  return (
    <DateMarker
      xValue={xValue}
      onClick={onClick}
      className={cn(
        "bg-secondary-100 px-2 text-secondary-700",
        onClick && "cursor-pointer hover:bg-secondary-200",
      )}
      icon={
        <Text as="span" variant="bodyStrong">
          {events.length}
        </Text>
      }
      label={t("productDetails:salesData.events.cluster.unit")}
      title={t("productDetails:salesData.events.cluster.title", {
        total: events.length,
      })}
      date={date}
      description={
        <ul className="min-w-52 space-y-1.5">
          {events.map((event) => (
            <MetadataEventClusterMarkerRow key={event.id} event={event} />
          ))}
        </ul>
      }
    />
  );
};
